import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-5"><path d="M20.25 4C21.2165 4 22 4.7835 22 5.75V8.5H17.25C15.7312 8.5 14.5 9.73122 14.5 11.25V12.75C14.5 14.2688 15.7312 15.5 17.25 15.5H22V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75C2 4.7835 2.7835 4 3.75 4H20.25Z" fill="currentColor"/><path d="M16 11.25C16 10.5596 16.5596 10 17.25 10H21.75C22.4404 10 23 10.5596 23 11.25V12.75C23 13.4404 22.4404 14 21.75 14H17.25C16.5596 14 16 13.4404 16 12.75V11.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconWallet5;
